import EastIcon from "@mui/icons-material/East";
import { Stack, Typography } from "@mui/material";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";

const HelpCard = ({ data }) => {
  const navigate = useNavigate();
  return (
    <Stack
      direction={"row"}
      alignItems={"center"}
      p={2}
      bgcolor={"text.white"}
      borderRadius={2.5}
      sx={{
        cursor: "pointer",
      }}
      onClick={() => navigate(`${data?.link}/${data?.type}`)}
    >
      <Typography
        fontSize={"1.125rem"}
        fontWeight={600}
        flexGrow={1}
        textTransform={"capitalize"}
      >
        {t(data?.title)}
      </Typography>
      <EastIcon htmlColor="text.black" />
    </Stack>
  );
};

export default HelpCard;
